import axios from 'axios';
import { BASE_URL, config } from '../constants';

export function getLenders(){
    return axios.get(`${BASE_URL}/lenders/`, config);
}